import classNames from "classnames";
import { useState } from "react";
import { Button } from "../../../components/Button/Button.tsx";
import { useAppMutation } from "../../../http/useAppMutation.ts";
import { MODEL_TYPE_LABELS } from "../../Board/display.ts";
import { useWorkspaceUuid } from "../../hooks/useWorkspaceUuid.ts";
import { ModelCreationLayout } from "../components/ModelCreationLayout.tsx";
import { ModelFormColumn } from "../components/ModelFormColumn.tsx";
import { useModel } from "../hooks/useModel.ts";

export const ModelNameForm = ({
  onClickPrevious,
  onClickNext,
}: {
  onClickPrevious: () => void;
  onClickNext: () => void;
}) => {
  const workspaceUuid = useWorkspaceUuid();
  const { model } = useModel();
  const [modelName, setModelName] = useState<string>(model.name ?? "");

  const { mutate: updateModel, isLoading: isUpdateModelLoading } =
    useAppMutation({
      path: "references/update",
      invalidate: [
        `workspaces/${workspaceUuid}/references`,
        `references/${model.uuid}`,
      ],
    }).mutation;

  return (
    <ModelCreationLayout
      showModelPreview
      title={`Give your ${MODEL_TYPE_LABELS[model.type]} a name`}
      onBack={onClickPrevious}
    >
      <ModelFormColumn>
        <div className={classNames("flex-col-center gap-600")}>
          <input
            type="text"
            className="w-full h-1000 py-200 px-400 rounded-100 border body-lg-default text-primary placeholder:text-disabled"
            placeholder={`My ${MODEL_TYPE_LABELS[model.type]}`}
            value={modelName}
            onChange={(event) => {
              setModelName(event.target.value);
            }}
          />
          <Button
            className="w-full"
            size="md"
            disabled={modelName.isEmpty()}
            loading={isUpdateModelLoading}
            onClick={() => {
              updateModel(
                {
                  uuid: model.uuid,
                  name: modelName,
                },
                {
                  onSuccess: onClickNext,
                },
              );
            }}
          >
            Next
          </Button>
        </div>
      </ModelFormColumn>
    </ModelCreationLayout>
  );
};
